import { Injectable,EventEmitter  } from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, tap, map} from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HomePageService {

  private showCoBorror: boolean = false;
  resizeEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(private http: HttpClient) { }

  store(data:any):Observable<any> {
    return this.http.post(environment.apiURL+'/surety/save-surety', data)
  }

  getToken() {
    return localStorage.getItem('token');
  }
  
  setShowCoBorrower(value: string)
  {
    if(value=='yes'){
      this.showCoBorror = true;
    }else{
      this.showCoBorror = false;
    }
  }

  getShowCoBorrower()
  {
    return this.showCoBorror;
  }

}
